module.exports = __webpack_public_path__ + "static/img/1051_phase_function_Paper_PointsHejduk_Prediction.d7a59a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1051_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 1Uch
// module chunks = 0